var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_231)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6828 4.94514C22.1371 4.30829 19.5913 3.03458 17.682 1.12402C15.7727 3.03458 13.2269 4.30829 10.6812 4.94514C11.3176 10.6768 13.2269 14.4979 17.682 17.6822C22.1371 14.4979 24.6828 10.6768 24.6828 4.94514Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1365 28.6578L4.31616 7.6416V17.8313L18.3179 33.7526L22.1365 28.6578Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0461 26.7476L31.6834 17.8316V8.27881L19.5911 22.2896L24.0461 26.7476Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6826 29.9319V35.6636L31.6835 27.3845V21.6528L24.6826 29.9319Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.317 29.9319L4.31616 21.6528V27.3845L11.317 35.6636V29.9319Z",
    fill: "#FBFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9506,
    height: 35.9739,
    fill: "white",
    transform: "translate(0.0249023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dce3145872188e100148c46882b30412.svg";
export { ForwardRef as ReactComponent };